"use client";

import { createElement } from "react";

import { getToolComponent } from "@/lib/tools/tool-components";

export function ToolMount({
  toolId,
}: {
  toolId: string;
}): null | React.JSX.Element {
  const Component = getToolComponent(toolId);
  if (!Component) return null;
  return createElement(Component);
}
